<template>
    <div>
         <div class="row justify-content-center">
          <div class="col-md-7" 
            :style="`background-image:url('${$store.state.data.undangan.gambar4}')`"
          style="background:#100001;position:relative;
          background-size:cover;background-repeat:no-repeat;background-position: center center;">
            <!-- <img src="@/static/draw1.jpeg" style="height:130vh;width:100%;position:absolute;right:0;top:0;z-index:10;" alt=""> -->
            <div  v-if="particle" style="height:100%;width:100%;position:absolute;z-index:1000;" id="particlesjspenutup" ></div>
            <br>
            <br>
            <br>
            <div style="height:180px;"></div>
              <div>
                <p class="text-center  font-semibold  text-2xl wow"
                :class="`${$store.state.data.undangan.animation=='random'?$store.state.animrandom[Math.floor(Math.random()*$store.state.animrandom.length)]:$store.state.data.undangan.animation}`"
                 style="font-family: 'Urbanist', sans-serif;">
                Mendo'a kan keberkahan bagi Pengantin Pria dan Wanita
                </p>  
                     <!-- <p class=" text-xl font-semibold  text-center" style="letter-spacing: 2px;word-spacing: 2px;font-family: 'Alex Brush', cursive;">
                        Wassalamualaikum Wr. Wb.
                    </p> -->
            <div style="height:50px;"></div>
                <p class="p-3 text-center text-3xl mt-4 wow"
                :class="`${$store.state.data.undangan.animation=='random'?$store.state.animrandom[Math.floor(Math.random()*$store.state.animrandom.length)]:$store.state.data.undangan.animation}`"
                style="font-family: 'Amiri', serif;">
                          بَارَكَ اللهُ لَكَ وَبَارَكَ عَلَيْكَ وَجَمَعَ بَيْنَكُمَا فِي خَيْرٍ
                </p>
                <p class="text-center  font-semibold  text-sm wow"
                :class="`${$store.state.data.undangan.animation=='random'?$store.state.animrandom[Math.floor(Math.random()*$store.state.animrandom.length)]:$store.state.data.undangan.animation}`"
                 style="font-family: 'Urbanist', sans-serif;">
                “Semoga Allah memberkahimu di waktu bahagia dan memberkahimu di waktu susah, serta semoga Allah mempersatukan kalian berdua dalam kebaikan” (HR. Abu Dawud no. 2130)
                </p>  

              </div>
            <div style="height:50px;"></div>
              <p class="text-center  font-semibold  text-xs mt-5 wow"
              :class="`${$store.state.data.undangan.animation=='random'?$store.state.animrandom[Math.floor(Math.random()*$store.state.animrandom.length)]:$store.state.data.undangan.animation}`"
                style="font-family: 'Urbanist', sans-serif;">
                  Sumber: https://muslim.or.id/22459-bila-di-undang-ke-walimah-nikah.html
              </p>
            <br>
            <br>
            <div style="height:100px;"></div>
          </div>
        </div>
    </div>
</template>
<script>
import 'particles.js'
import axios from "axios";
export default {
  props:['particle'],
  data() {
    return {
     
    };
  },
  components: {
  },
  mounted() {
        window.particlesJS("particlesjspenutup", this.$store.state.particle)
  },
  methods: {
    
  },
};
</script>